/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { toAbsoluteUrl } from '../../../_metronic/helpers';
import { Capacitor } from '@capacitor/core';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser';
import './DashboardLinkWidget.css'; // Import CSS for spinner in the browser

type Props = {
  className: string;
  title: string;
  description: string;
  avatar: string;
  link: string | undefined;
};

export function linkview(link: string | undefined, title: string, setLoading: (loading: boolean) => void) {
  setLoading(true);

  if (Capacitor.isNativePlatform()) {
    if (title.toLowerCase() === 'ecard') {
      window.open(link, '_blank');
      setLoading(false);
    } else {
      const options: InAppBrowserOptions = {
        zoom: 'no',
        location: 'yes',
        hideurlbar: 'yes',
        toolbarcolor: '#ffffff',
      };

      const browser = InAppBrowser.create(link!, '_blank', options);

      // Inject a spinner into the In-App Browser
      const injectSpinner = () => {
        browser.executeScript({
          code: `
            if (!document.querySelector('.loading-spinner')) {
              var spinner = document.createElement('div');
              spinner.className = 'loading-spinner';
              document.body.appendChild(spinner);
              var style = document.createElement('style');
              style.type = 'text/css';
              style.innerHTML = \`
                .loading-spinner {
                  position: fixed;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  z-index: 9999;
                  border: 16px solid #f3f3f3;
                  border-radius: 50%;
                  border-top: 16px solid #3498db;
                  width: 120px;
                  height: 120px;
                  animation: spin 2s linear infinite;
                }
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              \`;
              document.head.appendChild(style);
            }
          `,
        });
      };

      // Remove the spinner after the page fully loads
      const removeSpinner = () => {
        browser.executeScript({
          code: `
            var spinner = document.querySelector('.loading-spinner');
            if (spinner) {
              spinner.parentNode.removeChild(spinner);
            }
          `,
        });
      };

      // Handle loading events
      browser.on('loadstart').subscribe(() => {
        injectSpinner(); // Show the spinner during loading
      });

      browser.on('loadstop').subscribe(() => {
        browser.executeScript({ code: `document.readyState === 'complete'` }).then((values: any[]) => {
          if (values[0]) {
            removeSpinner(); // Remove the spinner when the page is fully loaded
            setLoading(false);
          }
        });
      });

      browser.on('loaderror').subscribe(() => {
        removeSpinner(); // Remove spinner on error
        setLoading(false);
      });

      browser.on('exit').subscribe(() => {
        removeSpinner(); // Remove spinner if the browser is closed
        setLoading(false);
      });

      browser.show();
    }
  } else {
    window.open(link, '_blank');
    setLoading(false);
  }
}

const DashboardLinkWidget: React.FC<Props> = ({ className, title, description, avatar, link }) => {
  return (
    <a
      onClick={() => {
        linkview(link, title, () => {});
      }}
      rel="noreferrer"
      className={`hoverable`}
    >
      <div
        className={`card bgi-no-repeat ${className}`}
        style={{
          backgroundPosition: 'right',
          backgroundSize: '18% auto',
          backgroundColor: '#fff',
          backgroundImage: `url(${toAbsoluteUrl('/media/futuriskicon/' + avatar)})`,
        }}
      >
        <div className="card-body mb-xl-8 ">
          <div className="card-title fw-bolder text-black text-hover-primary fs-4">{title}</div>
          <p
            className="text-muted fw-bold fs-7 m-0"
            dangerouslySetInnerHTML={{ __html: description }}
          ></p>
        </div>
      </div>
    </a>
  );
};

export { DashboardLinkWidget };
